import { useTranslation } from "react-i18next";
import { useDrawersContext } from "../routes/tasks/drawers-context";
import { Modal } from "./modal/Modal";
import { Text } from "./Text";
import { Flex } from "./Flex";
import { Info } from "./Info";
import { PrivatePricingPlans } from "../routes/subscription/components/PrivatePricingPlans";
import styled from "styled-components";
import { AtiraImage } from "./Image";
import { Images } from "../assets";
import capitalize from "lodash/capitalize";
import { useTheme } from "../ThemeContext";

const Separator = styled(Flex)`
  height: 1px;
  width: 90%;
  background-color: ${({ theme }) => theme.darkerSub};
`;

const ScrollArea = styled(Flex)`
  max-height: 70vh;
  overflow-y: auto;
  width: 100%;
`;

export const SubscribeToUnlockModal: React.FC = () => {
  const { subToUnlock, setSubToUnlock } = useDrawersContext();
  const { t } = useTranslation();
  const { selectedTheme } = useTheme();

  if (!subToUnlock.visible) {
    return null;
  }

  return (
    <Modal
      open={subToUnlock.visible}
      title={t("subToUnlock.title")}
      onClose={() => setSubToUnlock({ ...subToUnlock, visible: false })}
      destroyOnHidden
      zIndex={10000}
      width="90%"
    >
      <ScrollArea flexDirection="column" gap="xl" alignItems="center">
        {subToUnlock.title ? <Info info={subToUnlock.title} size="m" /> : null}

        <PrivatePricingPlans />
      </ScrollArea>
    </Modal>
  );
};
